import type { AuditLoad } from 'commons/modules/service/audit-load';
import { createReportSlice } from './reportStore';

// Initial filter keys for AuditLoad report
const initialFilters = {
  account: '',
};

// Create generic slice instance for this report
const slice = createReportSlice<AuditLoad>(
  'operationAuditLoad',
  initialFilters,
);

// Reducer
export default slice.reducer;
